import { createSelector } from 'reselect';
import { createSelectorHook, selectProp } from '../../utils/selectors';
import { initialState } from './reducers';

// Action creators are generated for each case reducer function
export const selectDomain = (state) => state.scanSession || initialState;

export const [selectThngId, useThngId] = createSelectorHook(
	selectDomain,
	selectProp('thngId')
);

export const [selectQrScanAuthResult, useSelectQrScanAuthResult] =
	createSelectorHook(selectDomain, ({ qrScanAuthResult }) => qrScanAuthResult);

export const [selectIsQrCodeRecognized, useIsQrCodeRecognized] =
	createSelectorHook(
		selectQrScanAuthResult,
		(result) => result?.customFields.authenticationStatus === 'positive'
	);

export const [selectQrScanId, useQrScanId] = createSelectorHook(
	selectQrScanAuthResult,
	(substate) => substate?.customFields?.triggerAction
);

export const [selectDigimarcScanAuthResult, useDigimarcScanAuthResult] =
	createSelectorHook(
		selectDomain,
		({ digimarcScanAuthResult }) => digimarcScanAuthResult
	);

export const [selectDigimarcScanId, useDigimarcScanId] = createSelectorHook(
	selectDigimarcScanAuthResult,
	(substate) => substate?.customFields?.triggerAction // todo: make sure this is right once digimarc scan is wired up
);

export const [selectLatestScanId, useLatestScanId] = createSelectorHook(
	selectDigimarcScanId,
	selectQrScanId,
	(digimarcScanId, qrScanId) => digimarcScanId || qrScanId
);

export const [selectAuthAlerts, useAuthAlerts] = createSelectorHook(
	selectQrScanAuthResult,
	(result) => {
		const childActions = result?.customFields.childActions || {};
		return Object.keys(childActions).filter(
			(key) => childActions[key].match === 'true'
		);
	}
);

export const [selectDigimarcTape, useDigimarcTape] = createSelectorHook(
	selectDomain,
	selectProp('digimarcTape')
);

export const [selectHasCameraPermission, useHasCameraPermission] =
	createSelectorHook(selectDomain, selectProp('hasCameraPermission'));

export const [selectIsLoading, useIsLoading] = createSelectorHook(
	selectDomain,
	selectProp('isLoading')
);

export const [selectIsToastOpen, useIsToastOpen] = createSelectorHook(
	selectDomain,
	selectProp('isToastOpen')
);

export const [selectIsDigimarcCorrect, useIsDigimarcCorrect] =
	createSelectorHook(selectDomain, selectProp('isDigimarcCorrect'));

export const [selectProductId, useProductId] = createSelectorHook(
	selectDomain,
	selectProp('productId')
);

export const [selectProduct, useProduct] = createSelectorHook(
	selectDomain,
	selectProp('product', {})
);
const selectProductPhotos = createSelector(
	selectProduct,
	selectProp('photos', [])
);
export const [selectProductPhoto, useProductPhoto] = createSelectorHook(
	selectProductPhotos,
	selectProp(0)
);
